import React from 'react';
import Rating from '@mui/material/Rating';

export default function StarRating({ value, onChange, readOnly = false, size = 'medium' }) {
  return (
    <Rating
      value={value ?? 0}
      onChange={onChange ? (_, newValue) => onChange(newValue) : undefined}
      precision={0.5}
      size={size}
      readOnly={readOnly}
    />
  );
}
